export const OPEN_PAGE_SETTINGS_MODAL = 'OPEN_PAGE_SETTINGS_MODAL';
export const CLOSE_PAGE_SETTINGS_MODAL = 'CLOSE_PAGE_SETTINGS_MODAL';

export const SAVE_PAGE_SETTINGS_START = 'SAVE_PAGE_SETTINGS_START';
export const SAVE_PAGE_SETTINGS_SUCCESS = 'SAVE_PAGE_SETTINGS_SUCCESS';
export const SAVE_PAGE_SETTINGS_FAILURE = 'SAVE_PAGE_SETTINGS_FAILURE';

export const UPDATE_DRAFT_COMMUNITY_OPTIONS = 'UPDATE_DRAFT_COMMUNITY_OPTIONS';

export const DELETE_PAGE_START = 'DELETE_PAGE_START';
export const DELETE_PAGE_SUCCESS = 'DELETE_PAGE_SUCCESS';
export const DELETE_PAGE_FAILURE = 'DELETE_PAGE_FAILURE';

export const COPY_PAGE_START = 'COPY_PAGE_START';
export const COPY_PAGE_SUCCESS = 'COPY_PAGE_SUCCESS';
export const COPY_PAGE_FAILURE = 'COPY_PAGE_FAILURE';

export const FETCH_ACCESS_SETTINGS_START = 'FETCH_ACCESS_SETTINGS_START';
export const FETCH_ACCESS_SETTINGS_SUCCESS = 'FETCH_ACCESS_SETTINGS_SUCCESS';
export const FETCH_ACCESS_SETTINGS_FAILURE = 'FETCH_ACCESS_SETTINGS_FAILURE';

export const UPDATE_ACCESS_SETTINGS = 'UPDATE_ACCESS_SETTINGS';
export const UPDATE_ACCESS_PERMISSIONS = 'UPDATE_ACCESS_PERMISSIONS';

export const FETCH_COHORT_SCHEDULING_OPTIONS_START =
  'FETCH_COHORT_SCHEDULING_OPTIONS_START';
export const FETCH_COHORT_SCHEDULING_OPTIONS_SUCCESS =
  'FETCH_COHORT_SCHEDULING_OPTIONS_SUCCESS';
export const FETCH_COHORT_SCHEDULING_OPTIONS_FAILURE =
  'FETCH_COHORT_SCHEDULING_OPTIONS_FAILURE';

export const UPDATE_DRAFT_COHORT_SCHEDULING_OPTIONS =
  'UPDATE_DRAFT_COHORT_SCHEDULING_OPTIONS';

export const FETCH_COMPLETION_OPTIONS_START = 'FETCH_COMPLETION_OPTIONS_START';
export const FETCH_COMPLETION_OPTIONS_SUCCESS =
  'FETCH_COMPLETION_OPTIONS_SUCCESS';
export const FETCH_COMPLETION_OPTIONS_FAILURE =
  'FETCH_COMPLETION_OPTIONS_FAILURE';

export const UPDATE_DRAFT_COMPLETION_OPTIONS =
  'UPDATE_DRAFT_COMPLETION_OPTIONS';
